import CallMergeIcon from "@mui/icons-material/CallMerge";
import { IconButton, Tooltip } from "@mui/material";
import t from "./translations";

type Props = {
  hasRawFiles: boolean;
  reference: string;
  onClick: () => void;
};

export default function MergeButton({
  hasRawFiles,
  reference,
  onClick,
}: Props) {
  return (
    <Tooltip title={hasRawFiles ? t.MergeAndImport : t.NothingToMerge} arrow>
      <span>
        <IconButton
          size="small"
          aria-label={t.MergeAndImport}
          disabled={!hasRawFiles}
          onClick={onClick}
          data-testid={`lidar-upload-status.merge.${reference}`}
        >
          <CallMergeIcon fontSize="small" />
        </IconButton>
      </span>
    </Tooltip>
  );
}
